import styled from 'styled-components';
import theme from '../../../theme';

export const RotationDropDownWrapper = styled.div`
    height: 200px;
    position: relative;
    overflow-y: auto;
    margin-top: 10px;
    background: ${theme.colors.background.lightGrey};
    padding: 5px;
    border: 1px solid ${theme.colors.border.light};
    border-radius: 4px;
    li {
        padding: 2px;
        &.selected {
            background-color: ${theme.colors.background.selected};
        }
        cursor: pointer;
    }

    .port-call-name {
        &.selected {
            background-color: ${theme.colors.background.selected};
        }
        font-weight: 600;
    }
    .berth-call-list {
        padding-left: 10px;
    }
`;
